import React from 'react';
import {classes, style} from './doppe-viewer-modal-panel-header.st.css';
import {DoppeViewerModalPanelSection} from '../doppe-viewer-modal-panel-section/doppe-viewer-modal-panel-section';
import {CommonClasses, FlexLayout} from '@wix/devzai-common-client';
import {DoppeViewerHorizontalButton} from '../doppe-viewer-horizontal-button/doppe-viewer-horizontal-button';
import {
    DoppeViewerAppIconArrowLeftMedium,
    DoppeViewerAppIconArrowRightMedium,
    DoppeViewerAppIconDismissMedium
} from '../doppe-viewer-icons/doppe-viewer-icons';
import {uiPartsGroupCreateMarking} from "@wix/devzai-utils-common";
import {DoppePageViewerPartsGroups} from "../doppe-page-viewer-part/doppe-page-viewer-part";
import {useDoppViewerIsRtl} from "../doppe-viewer-bymo-page-props-react/doppe-viewer-bymo-page-props-react";
import {cssEllipsis} from '@wix/devzai-utils-react';

export const DoppeViewerModalPanelHeader = React.memo(function DoppeViewerModalPanelHeader (props: DoppeViewerModalPanelHeader.Props) {
    const {
        title,
        subtitle,
        subtitleLines = 3,
        backButtonCallback,
        dismissButtonCallback,

        className,
        ...htmlAttributes
    } = props;

    const isRtl = useDoppViewerIsRtl();


    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {
                hasTitle: title !== '',
            }, className, FlexLayout.column.default)}
        >
            <DoppeViewerModalPanelSection
                className={style(classes.content, FlexLayout.row.alignToCenter)}
            >
                <DoppeViewerHorizontalButton
                    className={style(classes.backButton, {hidden: backButtonCallback === undefined})}
                    prefixIcon={isRtl ? DoppeViewerAppIconArrowRightMedium : DoppeViewerAppIconArrowLeftMedium}
                    textual={true}
                    {...uiPartsGroupCreateMarking(DoppePageViewerPartsGroups.BackButton)}
                    onClick={() => {
                        backButtonCallback?.();
                    }}
                />
                <div
                    className={style(classes.titleHeader, FlexLayout.column.default, FlexLayout.fillRemainingHorizontalSpace)}
                >
                    {
                        title ?
                            <div className={style(classes.title, {}, cssEllipsis())}>{title}</div>
                            :
                            null
                    }
                    {
                        subtitle ?
                            <div className={style(classes.subtitle, {}, CommonClasses.lineClamp(subtitleLines))}>{subtitle}</div>
                            :
                            null
                    }
                </div>
                <DoppeViewerHorizontalButton
                    className={style(classes.dismissButton, {hidden: dismissButtonCallback === undefined})}
                    prefixIcon={DoppeViewerAppIconDismissMedium}
                    textual={true}
                    {...uiPartsGroupCreateMarking(DoppePageViewerPartsGroups.CloseButton)}
                    onClick={() => {
                        dismissButtonCallback?.();
                    }}
                />
            </DoppeViewerModalPanelSection>
        </div>
    );
});

export namespace DoppeViewerModalPanelHeader {

    export interface Props extends React.HTMLAttributes<any> {
        title: string;
        subtitle?: string;
        subtitleLines?: 2 | 3 | 4 | 8;
        backButtonCallback?: () => void;
        dismissButtonCallback?: () => void;
    }
}
